import { MobileSlotButton } from './MobileSlotButton';

export default MobileSlotButton;
